/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type AccountTransactionPaginatedProperty =
  typeof AccountTransactionPaginatedProperty[keyof typeof AccountTransactionPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountTransactionPaginatedProperty = {
  TRANSACTION_AMOUNT: 'TRANSACTION_AMOUNT',
  CUSTOMER_ACCOUNT_BALANCE: 'CUSTOMER_ACCOUNT_BALANCE',
  PRODUCT_ACCOUNT_BALANCE: 'PRODUCT_ACCOUNT_BALANCE',
  TRANSACTION_DIRECTION: 'TRANSACTION_DIRECTION',
  BALANCE_CHANGE_SUBJECT_TYPE: 'BALANCE_CHANGE_SUBJECT_TYPE',
  PRODUCT_TYPE: 'PRODUCT_TYPE',
  PRODUCT_NAME: 'PRODUCT_NAME',
  PLATFORM_NAME: 'PLATFORM_NAME',
  BANK_NAME: 'BANK_NAME',
  CREATED_AT: 'CREATED_AT',
} as const;
